import React, { HTMLAttributes } from "react";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Social: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  // const {isLogin} = store.user;
  const TradingPlatformHtml = () => {
    return (
      <div dangerouslySetInnerHTML={{ __html: t('aboutus.TradingPlatform') }} />
    )
  }

  return (
    <div className={cx(`${styles.socializing}`, className)}>
      <div className={cx(`${styles.titleBox, styles.titleAll}`, className)}>
        { TradingPlatformHtml() }
      </div>
      <div className={cx(`${styles.desBOX, styles.desAll}`, className)}>
        <div>{ t("aboutus.platformIntroduce3") }</div>
      </div>
      <div className={cx(`${styles.imgBox}`, className)} style={{ backgroundImage: `url(${require("@/assets/images/aboutus/phone.svg")})`}}></div>
    </div>
  );
};

export default Social;
